<template>
	<div v-html="innerText" :contenteditable="canEdit" @focus="isLocked = true" @blur="isLocked = false;getLastPosition();" @input="changeText">
	</div>
</template>

<script type="text/ecmascript-6">
	export default{
		name: 'editDiv',
		props: {
			value: {
				type: String,
				default: ''
			},
			canEdit: {
				type: Boolean,
				default: true
			},
		},
		data(){
			return {
				innerText: this.value,
				isLocked: false,
				insertPositionObj: null,
				insertPositionVal: 0,
			}
		},
		watch: {
			'value'(){
				// if (!this.isLocked || !this.innerText) {
				if (!this.isLocked && !this.innerText) {
					this.innerText = this.value;
				}
			}
		},
		methods: {
			changeText(){
				this.$emit('input', this.$el.innerHTML);
			},
			insertData(data){},
			getLastPosition(){
				var sel, range;
				if (window.getSelection) { // IE9 and non-IE
					sel = window.getSelection();
					if (sel.getRangeAt && sel.rangeCount) {
						range = sel.getRangeAt(0);
						range.deleteContents();

						this.insertData = function(data){
							var el = document.createElement("div");
							el.innerHTML = data;
							var frag = document.createDocumentFragment(), node, lastNode;
							while ((node = el.firstChild)) {
								lastNode = frag.appendChild(node);
							}
							range.insertNode(frag);

							if (lastNode) {
								range = range.cloneRange();
								range.setStartAfter(lastNode);
								range.collapse(true);
								sel.removeAllRanges();
								sel.addRange(range);
							}
						}
					}
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/app/pages/admin/index/reject-textarea.vue